export const navigation = () => {
	toggle()
	dropdowns()
}

const dropdowns = () => {
	const els = document.querySelectorAll('.menu-item-has-children')

	if (!els.length) return

	els.forEach(el => {
		const submenu = el.querySelector('.sub-menu')
		const indicator = document.createElement('button')

		indicator.className = 'indicator'
		indicator.setAttribute('type', 'button')
		indicator.setAttribute('aria-label', 'Toggle submenu')
		indicator.setAttribute('aria-expanded', 'false')

		if (submenu) {
			let id = `submenu-${Math.random().toString(36).slice(2, 8)}`
			submenu.id = id
			indicator.setAttribute('aria-controls', id)
			submenu.setAttribute('aria-hidden', 'true')
		}

		el.appendChild(indicator)

		let toggle = () => {
			const expanded = indicator.getAttribute('aria-expanded') === 'true'
			indicator.setAttribute('aria-expanded', String(!expanded))
			if (submenu) submenu.setAttribute('aria-hidden', String(expanded))
		}

		indicator.addEventListener('click', toggle)

		indicator.addEventListener('keydown', e => {
			if (e.key === ' ' || e.key === 'Enter') {
				e.preventDefault()
				toggle()
			}
		})
	})
}

const toggle = () => {

	let button = document.querySelector('[data-toggle-navigation]'),
		nav = document.querySelector('.site-navigation')

	if (!button || !nav) return

	button.addEventListener('click', e => {
		e.preventDefault()

		let expanded = button.getAttribute('aria-expanded') === 'true'

		button.setAttribute('aria-expanded', !expanded)
		button.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu')

		if (expanded) {
			nav.hidden = true
		} else {
			nav.hidden = false
		}
	})

	document.addEventListener('keydown', e => {
		if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
			button.setAttribute('aria-expanded', 'false')
			button.setAttribute('aria-label', 'Open menu')
			nav.hidden = true
		}
	})
}

export default () => { }